import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import View from './View';
import Data from './Data';

const DasDLRBlockEdit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  return (
    <>
      <View {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <Data
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default DasDLRBlockEdit;
